import React from 'react';
import { Link } from 'react-router-dom';

const InfoSection = () => {
  return (
    <section className="font-sinhala max-w-5xl mx-auto my-16 px-4 z-20">
      
      <h3 className="text-2xl font-bold text-slate-800 mb-4 flex items-center gap-3">
        <span className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 text-sm">✦</span>
        ඉතා පහසුවෙන් ගනුදෙනු කිරීම සඳහා
      </h3>
      <p className="text-slate-600 mb-6 leading-relaxed">
        කසුන් වලකුඹුර Science අධ්‍යාපන කේන්ද්‍රය සමග ඉතා පහසුවෙන් ගනුදෙනු කිරීම සඳහා පහත දුරකථන අංක භාවිතා කර වට්ස්ඇප්(WhatsApp) පණිවිඩයක් යොමු කරන්න.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-10">
        {/* Left Side: Contact & Registration Instructions */}
        <div className="space-y-6">
          <div className="bg-gradient-to-br from-orange-500 to-red-600 text-white p-6 rounded-2xl shadow-lg shadow-orange-500/20 leading-relaxed font-medium">
            <p className="mb-4 text-orange-50">ඔබට මෙම WebSite එකට Register වීමේදී ගැටළුවක් ඇති වුවහොත් ගැටලුව ඇති තැන screenshot එකක් සමග 0740251710 අංකයට අනිවාර්යයෙන් WhatsApp පණිවිඩයක් එවන්න.</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="mt-1 opacity-80">👉</span>
                පන්ති පිළිබඳ වැඩිදුර තොරතුරු අවශ්ය නම් පන්තියේ නම සඳහන් කර 0740251710 WhatsApp කරන්න.
              </li>
            </ul>
          </div>
          
          <p className="text-slate-500 font-medium bg-slate-50 inline-block px-4 py-2 rounded-lg">මෙය ඔබට හා අපට ඉතා පහසු බැවින් හොඳින් කියවන්න.</p>
          
          <div className="flex flex-wrap gap-4">
            <Link to="/register" className="font-sans inline-block text-center bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold py-3 px-8 rounded-xl shadow-lg shadow-orange-500/30 hover:-translate-y-1 hover:shadow-xl hover:shadow-orange-500/40 transition-all duration-300">
              Register Now
            </Link>
            <Link to="/login" className="font-sans inline-block text-center bg-white text-orange-600 font-bold py-3 px-8 rounded-xl border border-orange-100 hover:bg-orange-50 hover:-translate-y-1 transition-all duration-300">
              Login
            </Link>
          </div>
        </div>

        {/* Right Side: Bank Details */}
        <div>
          <div className="bg-white rounded-xl border border-slate-100 shadow-lg p-4 sm:p-6">
            <div className="flex items-center justify-between mb-5">
              <div>
                <h2 className="text-sm sm:text-base font-black text-slate-800 mb-0.5">Bank Details (බැංකු ගිණුම් විස්තර)</h2>
                <p className="text-[9px] text-slate-400 font-bold uppercase tracking-widest">Transfer your payment here</p>
              </div>
              <img src="https://www.lankahost.lk/Content/ux/images/Bank_of_Ceylon.svg.png" alt="BOC Logo" className="h-9 sm:h-11 object-contain" />
            </div>

            <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-3">
              <div>
                <span className="text-[8px] text-slate-400 font-bold uppercase tracking-widest">Account Number</span>
                <p className="text-xl sm:text-2xl font-black text-orange-500 tracking-wider">95861437</p>
              </div>
              <div>
                <span className="text-[8px] text-slate-400 font-bold uppercase tracking-widest">Account Name</span>
                <p className="text-xs font-black text-slate-800 uppercase mt-0.5">W.G Kasun Manoj Kumarasinghe</p>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <span className="text-[8px] text-slate-400 font-bold uppercase tracking-widest">Bank</span>
                  <p className="text-xs font-bold text-slate-800 mt-0.5">BOC</p>
                </div>
                <div>
                  <span className="text-[8px] text-slate-400 font-bold uppercase tracking-widest">Branch</span>
                  <p className="text-xs font-bold text-slate-800 mt-0.5">Polgahawela</p>
                </div>
              </div>
            </div>

            <div className="mt-4 p-3 bg-blue-50 rounded-xl border border-blue-100">
              <p className="text-[9px] text-blue-600 font-bold leading-relaxed">
                * After transferring, go to <strong>Courses</strong> → select your month → upload payment slip to unlock materials.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="pt-8 border-t border-slate-100">
        <p className="font-bold text-slate-700 mb-4 flex items-center gap-2">
          WebSite එකට පුරනය(Login) වන ආකාරය <span className="animate-bounce">👇</span>
        </p>
        <div className="w-full max-w-2xl aspect-video bg-slate-900 rounded-2xl flex items-center justify-center text-white shadow-2xl relative overflow-hidden group">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900/80 pointer-events-none"></div>
          <div className="flex items-center gap-2 transform group-hover:scale-110 transition-transform duration-300 cursor-pointer">
            Watch on <span className="text-red-500 font-bold tracking-tighter text-xl">YouTube</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;

